import React from "react";

const ProfileIcon = (props) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M12 13.9872C16.3386 13.9872 20 14.6922 20 17.4122C20 19.25 16.3146 22.25 12 22.25C7.66237 22.25 4 19.25 4 17.3882C4 14.6672 7.68538 13.9872 12 13.9872ZM12 1.75C14.9391 1.75 17.294 4.60402 17.294 7.54105C17.294 10.4781 14.9391 12.8331 12 12.8331C9.0619 12.8331 6.70601 10.4781 6.70601 7.54105C6.70601 4.60402 9.0619 1.75 12 1.75Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default ProfileIcon;
